const filterConfig = [
  {
    name: 'dateFrom',
    type: 'date'
  },
  {
    name: 'dateEnd',
    type: 'date'
  }
];

export default filterConfig;
